import React, { useContext, useEffect, useRef, useState } from 'react';
import { Search } from 'react-bootstrap-icons';

import { MapContext } from '../../context/map';
import useTranslation from '../../hooks/use_translation';

const LocationMapSearch = () => {
	const { map } = useContext(MapContext);
	const [autocomplete, setAutocomplete] = useState();
	const ref = useRef();
	const { t } = useTranslation('component_location_map_search');

	useEffect(() => {
		if (ref.current && map) {
			setAutocomplete(
				new window.google.maps.places.Autocomplete(ref.current, {
					componentRestrictions: { country: 'se' },
					types: ['(regions)'],
				}),
			);
		}
	}, [ref, map]);

	useEffect(() => {
		if (autocomplete) {
			autocomplete.addListener('place_changed', () => {
				const place = autocomplete.getPlace();
				if (!place.geometry || !place.geometry.location) {
					return;
				}

				if (place.geometry.viewport) {
					map.fitBounds(place.geometry.viewport);
					const currentZoom = map.getZoom();
					if (currentZoom > 11) {
						map.setZoom(11);
					}
				} else {
					map.setCenter(place.geometry.location);
					map.setZoom(17);
				}
			});
		}
	}, [autocomplete, map]);

	return (
		<div className="input-group input-group-lg mb-3 ">
			<span className="input-group-text sm pe-0 bg-gray-100" id="">
				<Search />
			</span>
			<input
				className="form-control bg-gray-100 sm border-start-0 "
				placeholder={t('t1')}
				ref={ref}
				type="text"
			/>
		</div>
	);
};

export default LocationMapSearch;
